import { useMemo } from 'react';
import { theme } from '@socrait/react';

export const useRenderHtmlConfig = () => {
  const fonts = useMemo(
    () => [
      theme.fonts.regular,
      theme.fonts.medium,
      theme.fonts.bold,
      theme.fonts.xbold,
      theme.fonts.roboto,
      theme.fonts.robotoMedium,
    ],
    [],
  );

  const defaultTagStyles = useMemo(
    () => ({
      body: { fontFamily: theme.fonts.regular },
      span: { fontFamily: theme.fonts.regular },
      h1: {
        fontFamily: theme.fonts.bold,
        fontWeight: theme.fontWeights.bold,
        fontSize: theme.fontSizes.xmedium,
        marginBottom: theme.spacing.small,
      },
      h2: {
        fontFamily: theme.fonts.bold,
        fontWeight: theme.fontWeights.bold,
        fontSize: theme.fontSizes.medium,
        marginTop: theme.spacing.medium,
        marginBottom: theme.spacing.xsmall,
      },
      h3: {
        fontFamily: theme.fonts.bold,
        fontWeight: theme.fontWeights.bold,
        fontSize: theme.fontSizes.small,
        marginTop: theme.spacing.small,
        marginBottom: theme.spacing.xsmall,
      },
      p: {
        fontFamily: theme.fonts.regular,
        fontSize: theme.fontSizes.medium,
        lineHeight: theme.lineHeights.regular,
        marginBottom: theme.spacing.small,
      },
      li: {
        fontFamily: theme.fonts.regular,
        fontSize: theme.fontSizes.medium,
        lineHeight: theme.lineHeights.regular,
        marginLeft: theme.spacing.large,
      },
      ul: { marginLeft: 0 },
      ol: { marginLeft: 0 },
      strong: { fontFamily: theme.fonts.bold, fontWeight: theme.fontWeights.bold },
      b: { fontFamily: theme.fonts.bold },
      em: { fontFamily: theme.fonts.regular, fontStyle: 'italic' as const },
    }),
    [],
  );

  return { fonts, defaultTagStyles } as const;
};
